<template>
  <div style="height: 100%;width: 100%;overflow: hidden;">
    <StandardSearchPageView
      ref="tableWrap"
      rowKey="id"
      :columns="columns"
      :queryParams="queryParams"
      :request-promise="loadList"
      :enableSearch="false"
    >
      <template v-slot:operation>
        <div class="quota-top">
          <span class="quota-summary">
            当前有效总额度 {{ totalQuota }}
          </span>
          <div class="quota-label">选择额度：</div>
          <a-select
            v-model="quotaAmount"
            allow-clear
            placeholder="请选择"
            class="quota-input"
            :loading="quotaLoading"
            :options="quotaSelectOptions"
          />
          <a-button type="primary" :loading="qrcodeLoading" @click="handleRecharge">充值支付</a-button>
        </div>
      </template>
      <template v-slot:statusText="{ record }">
        {{ getStatusText(record) }}
      </template>
    </StandardSearchPageView>

    <a-modal
      title="微信支付"
      :visible="qrcodeVisible"
      :footer="null"
      :width="360"
      @cancel="closeQrcodeModal"
    >
      <div class="qrcode-wrap">
        <a-spin :spinning="qrcodeLoading">
          <img v-if="qrcodeUrl" :src="qrcodeUrl" alt="支付二维码" class="qrcode-img">
        </a-spin>
        <div class="qrcode-tip">请使用微信扫码完成支付</div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import StandardSearchPageView from '@/customComponents/standard/StandardSearchPageView.vue'
import { axios } from '@/utils/request'

export default {
  name: 'QuotaTab',
  components: {
    StandardSearchPageView
  },
  data() {
    return {
      quotaAmount: undefined,
      quotaLoading: false,
      qrcodeLoading: false,
      qrcodeVisible: false,
      qrcodeUrl: '',
      quotaOptions: [],
      totalQuota: 0,
      queryParams: {},
      columns: [
        { title: '总额度', dataIndex: 'totalQuota', width: 140 },
        { title: '有效期间时间', dataIndex: 'validTimeStr', width: 180 },
        { title: '订单金额', dataIndex: 'orderAmount', width: 120 },
        { title: '订单号', dataIndex: 'orderNo', width: 140 },
        { title: '更新时间', dataIndex: 'updatedTime', width: 180 },
        {
          title: '状态',
          dataIndex: 'status',
          scopedSlots: { customRender: 'statusText' },
          width: 100
        }
      ]
    }
  },
  computed: {
    quotaSelectOptions() {
      return this.quotaOptions.map(item => ({
        label: item.value,
        value: item.key
      }))
    }
  },
  created() {
    this.loadQuotaOptions()
    this.loadTotalQuota()
  },
  beforeDestroy() {
    this.clearQrcodeUrl()
  },
  methods: {
    loadQuotaOptions() {
      this.quotaLoading = true
      this.getHttpServices().getNewServeService()
        .post('/smsMerchantQuota/getQuotaList')
        .then(list => {
          this.quotaOptions = Array.isArray(list) ? list : []
        })
        .catch(err => {
          this.quotaOptions = []
          this.showNetWorkErrorMessage(err)
        })
        .finally(() => {
          this.quotaLoading = false
        })
    },
    loadTotalQuota() {
      this.getHttpServices().getNewServeService()
        .post('/smsMerchantQuota/queryQuota')
        .then(data => {
          this.totalQuota = data != null ? data : 0
        })
        .catch(() => {
          this.totalQuota = 0
        })
    },
    loadList(requestParams) {
      const { limitDto } = requestParams
      return this.getHttpServices().getNewServeService().post('/smsMerchantQuota/page', {
        limitDto,
        merchantName: ''
      })
    },
    getStatusText(record) {
      if (record.statusDesc) {
        return record.statusDesc
      }
      return Number(record.status) === 1 ? '有效' : '失效'
    },
    clearQrcodeUrl() {
      if (this.qrcodeUrl) {
        URL.revokeObjectURL(this.qrcodeUrl)
        this.qrcodeUrl = ''
      }
    },
    closeQrcodeModal() {
      this.qrcodeVisible = false
      this.clearQrcodeUrl()
      this.loadTotalQuota()
      if (this.$refs.tableWrap) {
        this.$refs.tableWrap.refresh(false)
      }
    },
    handleRecharge() {
      if (this.quotaAmount === undefined || this.quotaAmount === null || this.quotaAmount === '') {
        this.$message.warning('请选择额度')
        return
      }
      const quotaCode = this.quotaAmount
      this.clearQrcodeUrl()
      this.qrcodeVisible = true
      this.qrcodeLoading = true
      axios({
        baseURL: this.getAppConfig().newServeUrl,
        url: `/smsMerchantQuota/payQrcode/${quotaCode}`,
        method: 'get',
        responseType: 'blob'
      }).then(blob => {
        if (blob && blob.type && blob.type.indexOf('application/json') !== -1) {
          const reader = new FileReader()
          reader.onload = () => {
            try {
              const res = JSON.parse(reader.result)
              this.showNetWorkErrorMessage(res)
            } catch (e) {
              this.$message.error('获取支付二维码失败')
            }
            this.qrcodeVisible = false
          }
          reader.readAsText(blob)
          return
        }
        this.qrcodeUrl = URL.createObjectURL(blob)
      }).catch(err => {
        this.qrcodeVisible = false
        this.showNetWorkErrorMessage(err)
      }).finally(() => {
        this.qrcodeLoading = false
      })
    }
  }
}
</script>

<style lang="less" scoped>
.quota-top {
  margin-top: -16px;
  display: flex;
  align-items: center;
  //margin-bottom: 16px;
}

.quota-label {
  margin-right: 8px;
}

.quota-input {
  width: 240px;
  margin-right: 12px;
}

.quota-summary {
  //margin-bottom: 16px;
  margin-right: 16px;
  color: rgba(0, 0, 0, 0.85);
}

.qrcode-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-height: 220px;
  padding: 8px 0;
}

.qrcode-img {
  width: 200px;
  height: 200px;
}

.qrcode-tip {
  margin-top: 12px;
  color: rgba(0, 0, 0, 0.65);
}
</style>
